import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyDemandContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class MyDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyDemand;
  }

  render() {
    return (
      <MasterLayout>
        <MyDemandContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(MyDemand);



// WEBPACK FOOTER //
// ./pages/users/MyDemand.jsx